module.exports = __webpack_public_path__ + "static/media/lima.337ba1ee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/lima.jpeg
// module id = 282
// module chunks = 0